export const formatCodigoProveedor = (IdCustomer) => {
    if(IdCustomer){
   return 'VC' + IdCustomer.toString().padStart(8,'0')
    }else{
        return ''
    }
}